import React from "react";
import ListFormat from '../../../Formatters/ListFormat';
import CurrencyFormat from '../../../Formatters/CurrencyFormat';

export default function ProductSpecificationsData(minAge, maxAge, minCoverageAmount, maxCoverageAmount, termLengths) {
    return {
        video: {
            name: "Why purchase Life Insurance?",
            link: "https://player.vimeo.com/video/213549517"
        },
        hideNeedsAnalysis:true,
        hideVideoLink:true,
        image: "product-landing/term/circle1.png",
        specs: [
            {
                title: "Term Life Insurance",
                text: "The most affordable option to financially protect your loved ones. It works by guaranteeing protection over a specific period — the term, usually 10 – 30 years. Your premiums will remain the same for the duration of the policy.",
            },
            {
                title: "Eligibility",
                text: `${minAge} - ${maxAge} years`,
            },
            {
                title: "Term Lengths",
                text: <span><ListFormat numbers={termLengths.map(n => n.value)} /> years</span>,
            },
            {
                title: "Coverage amount",
                text: <span><CurrencyFormat number={minCoverageAmount} whole /> - <CurrencyFormat number={maxCoverageAmount} whole /></span>,
            },
            {
                title: "Who can apply?",
                text: `U.S. citizens or permanent residents ages ${minAge}-${maxAge}`
            },
            {
                title: "Death Benefit",
                text: "Yes, paid tax free"
            }

        ]

    }
}


// WEBPACK FOOTER //
// ./src/components/Helpers/Data/Products/Term/ProductSpecificationsData.js